import { render } from "./edit-sekolah.vue?vue&type=template&id=0be9a086&ts=true"
import script from "./edit-sekolah.vue?vue&type=script&lang=ts"
export * from "./edit-sekolah.vue?vue&type=script&lang=ts"

import "./edit-sekolah.vue?vue&type=style&index=0&id=0be9a086&lang=scss"

import exportComponent from "/codebuild/output/src3714422101/src/github.com/teknologi-kartu/crm-web-admin-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__